import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "form-label" }
const _hoisted_3 = { class: "form-icon position-relative" }
const _hoisted_4 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args))),
        class: "form-select"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (value, key) => {
          return (_openBlock(), _createElementBlock("option", {
            key: key,
            value: key,
            selected: _ctx.modelValue ? key === _ctx.modelValue.toLowerCase() : false
          }, _toDisplayString(value), 9, _hoisted_4))
        }), 128))
      ], 32)
    ])
  ]))
}